module.exports = __webpack_public_path__ + "assets-cabinet/img/preview-icon.a85d2c34.svg";